import { mobileDevice } from '@bingads-webui-campaign-react/common-hooks';

export const getPromotionBannerStyles = (_, { palette = {} }) => ({
  promotionBanner: {
    width: '100%',
    minWidth: 540,
    [mobileDevice]: {
      minWidth: 'auto',
    },
    '& .alert-coupon': {
      height: 32,
      minHeight: 32,
      backgroundColor: '#038387',
      display: 'flex',
      alignItems: 'center',
      color: palette.white,
      fontSize: 14,
    },

    '& .alert__content': {
      display: 'flex',
      paddingLeft: 5,
    },
  },
});
